import { h, Component, render, createRef } from 'preact';
import { LazyLoadedBackgroundImage } from '../stuff-explorer/lazy-loaded-image';

// we need a local cache because our slider likes to duplicate slide elements
const storyCache = [];

function fetchStory(url) {
  const cacheResult = storyCache.find(item => item.key === url);
  if (cacheResult) {
    return cacheResult.promise;
  } else {
    const promise = new Promise((resolve, reject) => {
      fetch(url)
      .then(response => response.json())
      .then(json => resolve(json));
    });
    storyCache.push({
      key: url,
      promise: promise
    });
    return promise;
  }
}

export default class EasternStoriesOffsiteSlideActivator {
  constructor() {
    [...document.getElementsByClassName('eastern-stories-offsite-slide')].forEach(function (element) {
      render(
        <EasternStoriesOffsiteSlide
          storyUrl={element.dataset['storyUrl']}
        />
        , element);
    });
  }
}

class EasternStoriesOffsiteSlide extends Component {

  constructor() {
    super();
    this.state = {
      thumbnailUrl: '',
      title: '',
      subTitle: '',
      excerpt: '',
      loadedState: 'loading',
    };
    this.containerRef = createRef();
  }

  componentDidMount() {
    let loadStarted = false;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!loadStarted && entries[0].isIntersecting) {
          loadStarted = true;
          this.loadStory();
        }
      }
    );
    observer.observe(this.containerRef);
  }

  loadStory() {
    try {
      // figure out the wp api URL from the full url
      const url = new URL(this.props.storyUrl);
      const matches = url.pathname.match(/([\w\-]+)\/?$/);
      const slug = matches[1];
      const apiUrl = url.origin + "/wp-json/wp/v2/posts?_embed&slug=" + encodeURIComponent(slug);
      const cachedFetchUrl = '/wp-json/ewu/api/fetchwithcache?url=' + encodeURIComponent(apiUrl);

      fetchStory(cachedFetchUrl)
      .then(json => {
        try {
          const story = json[0];
          const maxExcerptWords = 15;
          let excerpt = story.excerpt.rendered
            .replace(/(<([^>]+)>)/ig, "");
          const excerptWordCount = excerpt.split(" ").length;
          if (excerptWordCount > maxExcerptWords) {
            excerpt = excerpt.split(" ").slice(0, maxExcerptWords).join(" ") + '...';
          }
          let thumbnailUrl = story?._embedded['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium_large?.source_url;
          if (!thumbnailUrl) {
            // try to get smaller size
            thumbnailUrl = story?._embedded['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium?.source_url;
          }
          if (!thumbnailUrl) {
            // fall back to default
            thumbnailUrl = `${wp.theme_uri}/assets/stories-header-background.jpg`;
          }
          const update = {
            excerpt: excerpt,
            title: story.title.rendered,
            thumbnailUrl: thumbnailUrl,
            loadedState: 'good',
          };
          this.setState(update);
        } catch (error) {
          console.log("Problem loading story data:", this.props.storyUrl, error);
          this.setState({
            loadedState: 'error',
          });
        }
      });
    } catch (error) {
      console.log("Network problem while fetching story data:", this.props.storyUrl, error);
      this.setState({
        loadedState: 'error',
      });
    }
  }

  render () {
    return (
      <div ref={(el) => this.containerRef = el}>
        {this.state.loadedState === 'good' && (
          <a
            href={this.props.storyUrl}
            target="_blank"
            className="eastern-stories__article"
          >
            <div data-module="eastern-stories-image" className="eastern-stories-image">
              <LazyLoadedBackgroundImage
                tagName="div"
                className="eastern-stories__slide-image"
                data-bg-image={this.state.thumbnailUrl}
              ></LazyLoadedBackgroundImage>
            </div>
            <div class="eastern-stories__slide-info">
              <h4 dangerouslySetInnerHTML={{__html: this.state.title}}></h4>
              <hr/>
              <div className="eastern-stories__slide-copy">
                <p dangerouslySetInnerHTML={{__html: this.state.excerpt}}></p>
              </div>
            </div>
          </a>
        )}
        {this.state.loadedState === 'loading' && (
          <div
            className="eastern-stories__article"
          >
            <div class="eastern-stories__slide-info">
              <div className="eastern-stories__slide-copy">
                <p>Loading...</p>
              </div>
            </div>
          </div>
        )}
        {this.state.loadedState === 'error' && (
          <a
            href={this.props.storyUrl}
            target="_blank"
            className="eastern-stories__article"
          >
            <div data-module="eastern-stories-image" className="eastern-stories-image">
              <LazyLoadedBackgroundImage
                tagName="div"
                className="eastern-stories__slide-image"
                data-bg-image={`${wp.theme_uri}/assets/stories-header-background.jpg`}
              ></LazyLoadedBackgroundImage>
            </div>
          </a>
        )}
      </div>
    );
  }

}
